import React, {useState } from 'react';
import { dataRef } from "./Firebase";
// import { ref, onValue } from 'firebase/database';
// import StartFirebase from './Firebase';

const style={
    bg:'bg-gradient-to-r from-[#345987] to-[#890543]'
};
// const db=StartFirebase();
const FirebaseOperation = ()=>{
    const [name, setName] = useState("{nam: 'Raj', adr: 'Bahadur'}");

    const WriteData=()=>{
        dataRef.ref().child("All").push().child("name").set(name)
        
        }


        // const ReadData=()=>{
            // const dbref=ref(db, 'All');
// 
            // onValue(dbref, (snapshot)=>{
// 
            // });
// 
        // }
    
        //setName("Tukkal");

   return(
        <>

        <div className={style.bg}>

        
        {/* dataRef.ref().child("All").push(name) */}
        
        {/* <p>{name}</p> */}
        <p style={{marginTop: '200px'}}>Hello Firebase {name}</p> 
        
        <button onClick={WriteData}>Add Data</button>
        {/* <button onClick={ReadData}>Read Data</button> */}



        {/* Hello Brother */}

        {/* <Red /> */}
        </div>
        </>
    );
}

export default FirebaseOperation;